export const shopQueryKeys = {
  id: 'id',
  name: 'shop_name',
  description: 'descr',
  createdAt: 'created_at',
  countryId: 'country_id',
};
